import { render } from "./FooterCard.vue?vue&type=template&id=2c13ae2b"
import script from "./FooterCard.vue?vue&type=script&lang=js"
export * from "./FooterCard.vue?vue&type=script&lang=js"
script.render = render

export default script